<template>
  <div class="">
    <VueApexCharts
      type="radar"
      :options="chartOptions"
      :series="series"
    ></VueApexCharts>
  </div>
</template>

<script setup>
import { ref } from "vue";
import VueApexCharts from "vue3-apexcharts";

const series = ref([
  {
    name: "Skill Level",
    data: [8, 9, 5, 6, 10],
  },
]);

const chartOptions = ref({
  chart: {
    height: 350,
    type: "radar",
    toolbar: {
      show: false,
    },
    // sparkline: {
    //   enabled: true, // This will limit the chart to the plot area
    // },
  },
  dataLabels: {
    enabled: false, // Disable data labels
  },
  title: {
    text: undefined,
  },
  markers: {
    size: 10,
    hover: {
      size: 15,
    },
  },
  tooltip: {
    fillSeriesColor: false, // Set to false to enable custom background
    theme: "dark", // Set to 'dark' for a dark tooltip background
    x: {
      show: false, // Disable title bar in tooltip
    },
  },
  xaxis: {
    categories: ["Linux", "Web", "Backend", "Databases", "Charisma"],
    labels: {
      style: {
        fontSize: "16px", // Increase the font size here
      },
    },
  },
  yaxis: {
    show: false, // Hide the y-axis
    min: 0, // Set the minimum value
    max: 10, // Set the maximum value
    labels: {
      show: false, // Hide y-axis labels
    },
  },
});
</script>
